import { useMutation } from '@apollo/client'

import { UPDATE_DOMAINS_PRODUCT_ENABLED } from './api/mutation'
import { Variables } from './api/types'
import { useSnackbar } from './useSnackbar'

export const useSwitchDomainsProduct = () => {
  const { snackbar } = useSnackbar()

  const [mutate] = useMutation(UPDATE_DOMAINS_PRODUCT_ENABLED, {
    refetchQueries: ['getDomains'],
  })

  const update = async (variables: Variables): Promise<void> => {
    const { enabledValue, productType } = variables
    const { data } = await mutate({ variables: { input: variables } })
    const { errors } = { ...data?.updateDomainsProductEnabled }

    if (errors && errors.length > 0) {
      snackbar(productType, enabledValue, 'error')
    } else {
      snackbar(productType, enabledValue)
    }
  }

  return { update }
}
